import { makeStyles } from '@material-ui/core';
import { useThemeColor } from '@themes/Colors';
import React from 'react';
import { HorizontalGrid, HorizontalGridProps } from './HorizontalGrid';
import clsx from 'clsx'

export type FilterBarProps = HorizontalGridProps & {
}

export function FilterBar (props: FilterBarProps) {
    const themeColor = useThemeColor();
    const cls = useStyles();

    return (
        <HorizontalGrid verticalAlign="center" spacing={1} className={clsx(cls.root, {
            [themeColor.component.gridFilterBar]: true,
        })} {...props} />
    )
}

const useStyles = makeStyles(theme => ({
    root : {
        padding: theme.spacing(1)
    }
}));